<div class="content-header">
  <div class="container-fluid">
    <div class="row mb-2">
      <div class="col-sm-6">
        <h1 class="m-0 text-dark">Dashboard</h1>
      </div>
      <!-- /.col -->
      <div class="col-sm-6">
        <ol class="breadcrumb float-sm-right">
          <li class="breadcrumb-item"><a href="#">Home</a></li>
          <li class="breadcrumb-item active">Dashboard v1</li>
        </ol>
      </div>
      <!-- /.col -->
    </div>
    <!-- /.row -->
  </div>
  <!-- /.container-fluid -->
</div>
<!-- /.content-header -->

<!-- Main content -->
<section class="content">
  <div class="container-fluid">
    <!-- Small boxes (Stat box) -->
    <mat-card>
      <mat-card-header
        class="loading-header"
        [ngClass]="{ loading: isLoading$ | async }"
      >
        <mat-progress-bar
          mode="indeterminate"
          *ngIf="isLoading$ | async"
        ></mat-progress-bar>

      </mat-card-header>

      <div class="row">
        <div class="col-lg-3 col-6">
          <!-- small box -->
          <div class="small-box bg-info">       
            <div class="inner">
             <h3 *ngIf="organisations">{{ organisations.length }}</h3> 
  
              <p>Organisations on the current env</p>
            </div>
            <div class="icon">
              <i class="ion ion-home"></i>
            </div>
            <a href="organisations" class="small-box-footer"
              >More info <i class="fas fa-arrow-circle-right"></i
            ></a>
          </div>
        </div>
        <!-- ./col -->
        <div class="col-lg-3 col-6">
          <!-- small box -->
          <div class="small-box bg-success">
            <div class="inner">
              <h3>53<sup style="font-size: 20px;">%</sup></h3>
  
              <p>Bounce Rate</p>
            </div>
            <div class="icon">
              <i class="ion ion-stats-bars"></i>
            </div>
            <a href="#" class="small-box-footer"
              >More info <i class="fas fa-arrow-circle-right"></i
            ></a>
          </div>
        </div>
        <!-- ./col -->
        <div class="col-lg-3 col-6">
          <!-- small box -->
          <div class="small-box bg-warning">
            <div class="inner">
              <h3>44</h3>
  
              <p>User Registrations</p>
            </div>
            <div class="icon">
              <i class="ion ion-person-add"></i>
            </div>
            <a href="#" class="small-box-footer"
              >More info <i class="fas fa-arrow-circle-right"></i
            ></a>
          </div>
        </div>
        <!-- ./col -->
        <div class="col-lg-3 col-6">
          <!-- small box -->
          <div class="small-box bg-danger">
            <div class="inner">
              <h3>65</h3>
  
              <p>Unique Visitors</p>
            </div>
            <div class="icon">
              <i class="ion ion-pie-graph"></i>
            </div>
            <a href="#" class="small-box-footer"
              >More info <i class="fas fa-arrow-circle-right"></i
            ></a>
          </div>
        </div>
        <!-- ./col -->
      </div>
    </mat-card>

    <!-- /.row -->

    <!-- Analytics Section -->
    <div class="analytics-section">
      <h3 class="section-title">Analytics & Insights</h3>

      <div class="analytics-grid">
        <!-- Collects AI Analytics Card -->
        <mat-card class="analytics-card" routerLink="/collects-ai-analytics">
          <mat-card-header>
            <mat-icon mat-card-avatar class="card-avatar">smart_toy</mat-icon>
            <mat-card-title>Collects AI Analytics</mat-card-title>
            <mat-card-subtitle>Waste Management Assistant</mat-card-subtitle>
          </mat-card-header>
          <mat-card-content>
            <p class="card-description">
              Track usage, sessions, performance metrics, and user feedback
            </p>
            <div class="card-metrics">
              <mat-chip-list>
                <mat-chip>
                  <mat-icon class="metric-icon">timeline</mat-icon>
                  Usage
                </mat-chip>
                <mat-chip>
                  <mat-icon class="metric-icon">thumb_up</mat-icon>
                  Feedback
                </mat-chip>
                <mat-chip>
                  <mat-icon class="metric-icon">speed</mat-icon>
                  Performance
                </mat-chip>
              </mat-chip-list>
            </div>
          </mat-card-content>
          <mat-card-actions align="end">
            <button mat-button color="primary">
              View Dashboard
              <mat-icon>arrow_forward</mat-icon>
            </button>
          </mat-card-actions>
        </mat-card>

        <!-- Placeholder for future analytics -->
        <mat-card class="analytics-card placeholder-card">
          <mat-card-header>
            <mat-icon mat-card-avatar class="card-avatar placeholder">add_circle_outline</mat-icon>
            <mat-card-title>More Analytics</mat-card-title>
            <mat-card-subtitle>Coming Soon</mat-card-subtitle>
          </mat-card-header>
          <mat-card-content>
            <p class="card-description">
              Additional analytics dashboards will be added here as new services are integrated
            </p>
          </mat-card-content>
        </mat-card>
      </div>
    </div>

  </div>
  <!-- Main row -->
</section>
<!-- /.content -->
